const formattedDate = (date: string) =>
  `Update ${new Date(date).toLocaleDateString('en-US')}`;

export { formattedDate };
